import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import PreviewListHeaderContainer from '../../components/PreviewListHeaderContainer';

const useStyles = makeStyles((theme: Theme) => {
  return {
    productName: {
      color: '#696969'
    },
    jumpIntoInformationContainer: {
      background: '#E0EFFF',
      borderRadius: 4,
      padding: theme.spacing(1) * 1.5,
      width: 380
    },
    otherInformationContainer: {
      background: '#EAEAEA',
      borderRadius: 4,
      padding: theme.spacing(1) * 1.5,
      width: 380,
      marginTop: 8
    },
    informationHeader: {
      fontWeight: 500
    },
    informationSubtitle: {
      fontWeight: 400
    }
  };
});

type GradeHeaderProps = {
  gradeLevel: string | null | undefined;
};

const GradeHeader: React.FC<GradeHeaderProps> = ({ gradeLevel }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <PreviewListHeaderContainer
      title={t('36 Week Preview')}
      chip={{ text: `Grade ${gradeLevel}`, backgroundColor: '#1A7034' }}
      subtitle="Keyboarding Without Tears"
    >
      <Grid
        item
        container
        justify="flex-end"
        direction="column"
        alignItems="flex-end"
        xs={12}
        md={6}
      >
        <Grid item className={classes.jumpIntoInformationContainer}>
          <Typography className={classes.informationHeader}>
            {'Skip “Jump Into Keyboarding”'}
          </Typography>
          <Typography variant="subtitle2" className={classes.informationSubtitle}>
            {t('Students in 3rd-5th grade will skip the first 6 weeks by default.')}
          </Typography>
        </Grid>
        <Grid item className={classes.otherInformationContainer}>
          <Typography variant="subtitle2" className={classes.informationSubtitle}>
            {t('Enrichment Activities are indicated with an asterisk (*) at the end.')}
          </Typography>
        </Grid>
      </Grid>
    </PreviewListHeaderContainer>
  );
};

export default GradeHeader;
